<i
  class="contextual-icon text-color-gray-7"
  [uiTooltipTitle]="'show_contextual_suggestion' | localize"
  (click)="toggle.emit()"
  ui-tooltip
  ui-icon
  uiType="platform-intelligence-default"
  uiTheme="outline">
</i>
